import React from 'react'
import { useState, useEffect } from 'react';
import axios from 'axios';
import '../../App.css';
import {Grid, TextField, Box, Button, Paper, Stack,FormControl,FormControlLabel,Checkbox, FormHelperText,Typography} from '@mui/material';
import {CropRotate, ArrowForwardIos} from '@mui/icons-material';
import * as employeeService from '../../services/employeeService';
import MultipleSelect from '../MultipleSelect';
import { getMonthList } from '../../services/monthList';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';

// Custom component for required field label with a red asterisk
const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red' , marginLeft: '3px'}}>*</span>
  </span>
);

const options = employeeService.getDepartmentCollection();
const monthOptions = getMonthList();


const initialFValues={
  id: 0,
  wfSalLimit: null,
  wfApplicable: false,
  wfEstdCode: "",
  empContriForBelow: "",
  compContriForBelow: "",
  empContriForAbove: null,
  compContriForAbove: null,
  effectiveDateFrom: "",
  monthsOfContribution: [],
}

let  noOfRows = 0;


function WF_ConfigurationForm(){
    const [values, setValues] = useState(initialFValues);
    const [errors, setErrors] = useState({});
    const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
    const navigate = useNavigate();
    
  const validate = () => {
    let temp = {}
    temp.wfEstdCode = values.wfEstdCode ? "" : "This field is required.";
    temp.empContriForBelow = values.empContriForBelow ? "" : "This field is required.";
    temp.compContriForBelow = values.compContriForBelow ? "" : "This field is required.";
    temp.effectiveDateFrom = values.effectiveDateFrom ? "" : "This field is required.";
    temp.monthsOfContribution = values.monthsOfContribution.length !== 0 ?"" : "Please Select atleast one Month";

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x === "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }


  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  }

  const handleMultiSelect = (list) => {
    setValues({
        ...values,
        ['monthsOfContribution']: list
    });
  }

  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  useEffect(() => {
    (async() => {
        try {
            const wfDetails = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/configure/wf-configure/get`);
            noOfRows = wfDetails.data.length;

            if(noOfRows) {
                const editFValues = {
                    wfSalLimit: null,
                    wfApplicable: wfDetails.data[0].WF_Applicable,
                    wfEstdCode: wfDetails.data[0].wf_estd_code || "",
                    empContriForBelow: wfDetails.data[0].empContriForBelow,
                    compContriForBelow: wfDetails.data[0].compContriForBelow,
                    empContriForAbove: null,
                    compContriForAbove: null,
                    effectiveDateFrom: wfDetails.data[0].effective_from_date || "",
                    monthsOfContribution: JSON.parse(wfDetails.data[0].monthsOfContribution),
                }
                setValues(editFValues);
            }
        } catch (e) {
          if(e.response.status === 401) {
            setNotify({
              isOpen: true,
              message: 'Session Expired!',
              type: 'error'
            });
            setTimeout(() => {
              navigate('/');
            },1000);
          }
        }
    })();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if(validate()){
      const payload = {
        ...values,
        wfSalLimit: null,
        empContriForAbove: null,
        compContriForAbove: null,
        wf_estd_code: values.wfEstdCode
      };
      delete payload.wfEstdCode;
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/configure/wf-configure/save/`+noOfRows, payload)
      .then(function (response) {
        if(response.status === 200) {
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: 'success'
          });
        }
      })
      .catch(function (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      });
      }
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px"}}>
      <Paper elevation={5} sx={{width: "600px", padding: "20px"}}>
        <Grid className="form-title" container spacing={2} alignItems="center" justifyContent="center">
          <Grid item> 
            <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>Welfare Fund Configuration</Typography> 
          </Grid>
          <Grid item> 
            <CropRotate style={{marginLeft: "-50px"}} sx={{width: 45, height: 45}}/> 
          </Grid>
        </Grid>
       
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit} style={{marginTop: "-60px"}}>
          <Stack spacing={2} sx={{margin: "30px", marginLeft: '5px'}}>
                <Stack direction="row" sx={{marginTop: '10px', marginBottom: '10px'}}>
                    <FormControl>
                        <FormControlLabel
                        sx={{marginLeft: '8px'}}
                            control={<Checkbox
                                name="wfApplicable"
                                color="primary"
                                checked={values.wfApplicable}
                                onChange={ e => handleInputChange(convertToDefEventPara("wfApplicable", e.target.checked))}
                                />}
                                label="Active?"
                        />
                    </FormControl>
                </Stack>
                {values.wfApplicable&&<>
                {/* <Button  variant="outlined" color="success" startIcon={<Preview sx={{width: "30px", height: "30px"}}/>} >Get Current Data</Button> */}
                <p style={{color: 'red',fontSize: '12px', marginTop: '10px', marginBottom: '0px', textAlign: 'left',marginLeft: '13px'}}> Note : All Fields are Mandatory </p>
                <Grid container spacing={2} sx={{marginTop: '20px', marginBottom: '20px'}}>
                    <Grid item xs={6}>
                        <TextField
                            variant="outlined"
                            name="wfEstdCode"
                            label={<RequiredLabel label="Establishment Code" />}
                            size="small"
                            fullWidth
                            inputProps={{ style: { textAlign: 'left' } }}
                            value={values.wfEstdCode}
                            onChange={handleInputChange}
                            {...(errors.wfEstdCode && {error:true, helperText: errors.wfEstdCode} )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            variant="outlined"
                            name="empContriForBelow"
                            label={<RequiredLabel label="Employee Contribution (&#8377;)" />}
                            size="small"
                            fullWidth
                            inputProps={{ style: { textAlign: 'left' } }}
                            value={values.empContriForBelow}
                            onChange={handleInputChange}
                            {...(errors.empContriForBelow && {error:true, helperText: errors.empContriForBelow} )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            variant="outlined"
                            name="compContriForBelow"
                            label={<RequiredLabel label="Company Contribution (&#8377;)" />}
                            size="small"
                            fullWidth
                            inputProps={{ style: { textAlign: 'left' } }}
                            value={values.compContriForBelow}
                            onChange={handleInputChange}
                            {...(errors.compContriForBelow && {error:true, helperText: errors.compContriForBelow} )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl {...(errors.effectiveDateFrom && {error:true} )} fullWidth>
                            <TextField
                                variant="outlined"
                                className="date-picker"
                                type="date"
                                size="small"
                                label={<RequiredLabel label="Effective Date From" />}
                                name="effectiveDateFrom"
                                value={values.effectiveDateFrom}
                                onChange={handleInputChange}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                inputProps={{ style: { textAlign: 'left' } }}
                                {...(errors.effectiveDateFrom && {error:true, helperText: errors.effectiveDateFrom} )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sx={{overflow: 'hidden', maxWidth: '100%'}}>
                        <Box sx={{width: '100%', maxWidth: '100%'}}>
                            <MultipleSelect 
                                options={monthOptions} 
                                label={<RequiredLabel label="Select Months" />}
                                size="small"
                                fullWidth={true}
                                error={!!errors.monthsOfContribution}
                                onMultiSelect={handleMultiSelect} 
                                savedOptions={values.monthsOfContribution}  //passing Fetched stored DB data
                            />
                            {errors.monthsOfContribution && <FormHelperText sx={{marginLeft: '14px', marginTop: '3px', textAlign: 'left'}}>{errors.monthsOfContribution}</FormHelperText>}
                        </Box>
                    </Grid>
                </Grid>
                <Stack direction="row" justifyContent="center" sx={{marginTop: '10px', marginBottom: '10px'}}>
                    <Button className="form-btn" variant="contained" endIcon={<ArrowForwardIos />} type="submit">Save</Button>
                </Stack>
                </>}

            </Stack>
        </form>
      </Paper>
      <Notification
            notify={notify}
            setNotify={setNotify} />
    </Box>
  )
}

export default WF_ConfigurationForm;
